import styled from '@emotion/styled';

export const WrapperUserMenu = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`;

export const WrapperImageUser = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  border: solid 1px black;
  border-radius: 50%;
`;

export const UserImage = styled.img`
  display: block;
`;
